module.exports = __webpack_public_path__ + "static/media/mobUX_White_Green.13a91025.png";